"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line lodash-fp/use-fp
var lodash_1 = require("lodash");
var fp_1 = require("lodash/fp");
function createIteratee(converter, self) {
    return function (result, value, key) {
        return lodash_1.set(result, converter(key), fp_1.isObjectLike(value) ? self(value) : value);
    };
}
function createHumps(keyConverter) {
    return function humps(node) {
        if (fp_1.isArray(node))
            return fp_1.map(humps, node);
        if (fp_1.isPlainObject(node))
            return lodash_1.transform(node, createIteratee(keyConverter, humps));
        return node;
    };
}
exports.default = createHumps;
//# sourceMappingURL=createHumps.js.map